import { AppType } from "@azm/core/enums/app-types";
import { EnvironmentMode } from "@azm/core/enums/environment-mode";
import { createEnvironment } from "./environment.shared";

export const environment = createEnvironment({
	production: false,
	mode: EnvironmentMode.Qc,
	appType: AppType.Internal,
  apiBaseUrl: "https://legalaffairs-qc.azm-cit.com/",
	enableAiTextAssist: true,
	enableThemeSwitch: false,
	enableAccessibilityTools: true,
});
